import { ApiHandler } from '@eshop/api-client'
import type { SORT_BY } from '@eshop/type'

import { ServiceProduct } from '#/global/service/Product'

import { Config } from '#/global/helper/Config'

export type ProductTypes = 'eshop' | 'rental'

export const fetchProductCodesByQuery = async (query: string, type: ProductTypes) => {
    const api = new ApiHandler({
        apiEndpoint: 'search',
        path: '/v2/{company}/products-{type}/full-search',
        pathParameters: {
            company: Config.getSearchCompany(),
            type,
        },
        parameters: {
            query,
            page: '1',
            items_per_page: '240',
        },
    })

    const data = await api.send<{ items: string[] }>()

    return data?.items ?? []
}

export const fetchProductCodesByFilters = async (productCodes: string[], filters: Record<string, string[] | number[]>, sortBy: SORT_BY, type: ProductTypes) => {
    const body = {
        [type === 'eshop' ? 'productCodes' : 'groupCodes']: productCodes,
        orderBy: sortBy === 'DEFAULT' ? 'DEFAULT' : 'PRICE',
        order: sortBy === 'DEFAULT' ? 'ASC' : (sortBy === 'LOW' ? 'ASC' : 'DESC'),
        availabilityIds: filters.AVAILABILITY?.map(value => +value),
        brandIds: filters.BRAND?.map(value => +value),
        minPrice: filters.PRICE?.[0],
        maxPrice: filters.PRICE?.[1],
    }

    const api = new ApiHandler({
        path: '/product/filter-products-{type}-by-search-filters',
        method: 'POST',
        pathParameters: {
            type,
        },
        body: JSON.stringify(body),
    })

    const data = await api.send<string[]>()

    return data ?? []
}

export const fetchProductsEshop = async (productCodes: string[], page: number) => {
    const start = (page - 1) * 24
    const end = page * 24
    const productCodesByPage = [...productCodes].slice(start, end)

    return ServiceProduct.getProductEshopByCode(productCodesByPage, ['detail', 'price', 'unit', 'availability', 'sticker'])
}

export const fetchProductsRental = async (productCodes: string[], page: number) => {
    const start = (page - 1) * 24
    const end = page * 24
    const productCodesByPage = [...productCodes].slice(start, end)

    return ServiceProduct.getProductRentalByCode(productCodesByPage, ['detail', 'sticker'])
}
